import TemplateView from '../../../../../js/TemplateView'
import {DEFAULT_SORTING} from '../../constants'
import {OrderedList} from '../../../../../js/components/OrderedList'

export default class FeedsTableContent extends TemplateView {

    constructor({
        renderFeed,
    }) {
        super()

        this.state = {
            feeds: [],
            sorting: DEFAULT_SORTING,
        }

        this.params = {
            renderFeed,
        }

        this.onStatePropertyChanged('feeds', feeds => {
            this.feedsList.setState({items: feeds})
        })

        this.onStatePropertyDeeplyChanged('sorting', sorting => {
            this.feedsList.setState({reverseOrder: !sorting.isAsc})
        })
    }

    templateHtml() {
        return `<div class='feedsTableContent'/>`
    }

    afterRender() {
        this.feedsList = new OrderedList({
            itemToComponent: this.params.renderFeed
        }).init(this.getEl())
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/table/FeedsTableContent.js